module.exports = __webpack_public_path__ + "images/anwb_small65f7f54ae8ca5e6b68046a43624bc07d.png";